export default __webpack_public_path__ + "static/media/ico-invoice.4dadae3c.svg";